// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCIdCF_k-cxVPDipqJu4k15RirzPeRDwPM",
  authDomain: "ejjeh-managment.firebaseapp.com",
  projectId: "ejjeh-managment",
  storageBucket: "ejjeh-managment.firebasestorage.app",
  messagingSenderId: "349951416098",
  appId: "1:349951416098:web:39fb071116f635b867377b"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);


